import React from 'react';
import history from '../history';
// ui
import { Button } from 'rmwc/Button';

const BreadcrumbTrail = ({ pageName }) => {

    if (pageName === 'Home') return null;

    /*if (pageName === 'Home') return (
        <div style={{ padding: 10, color:'#aaa' }}>
            <Button theme={'secondary'} dense  onClick={() => history.push('/')}>
                the fallen
            </Button>
            ||
            <Button dense  onClick={() => history.push('/')}>
                ww1
            </Button>
            ||
            <Button dense  onClick={() => history.push('/')}>
                the project
            </Button>
        </div>
    );*/

    return (
        <div style={{ padding: 10, color:'#aaa'  }}>
            <Button theme={'secondary'} dense  onClick={() => history.push('/')}>
                home
            </Button>
            /
            <Button disabled={true} dense>
                {pageName}
            </Button>
        </div>
    )
};

export default BreadcrumbTrail;


// WEBPACK FOOTER //
// ./src/app/components/BreadcrumbTrail.js